// 副露（TMeld）型別定義
// 對應 PRD §13.3 TMeld
//
// 副露＝玩家透過吃/碰/槓動作從他人捨牌（或自摸）形成的「公開面子」。
// 這些牌不再放在暗牌區，獨立顯示在副露區（PRD §3.2.1）。
//
// 暗槓特殊：四張同種牌全部來自玩家自己手中，雖然「副露」但不公開全部資訊
// （UI 顯示為 4 張背面 + 中間 2 張正面，或全部背面），規則上仍視為一個面子。

import type { TTile } from './tile';
import type { TSeat } from './types';

/**
 * 副露種類 const：
 * - `Chi`：吃（同花色順子，僅可吃上家）
 * - `Pong`：碰（三張同種牌，可吃任一家捨牌）
 * - `KongExposed`：明槓（四張同種，由他人捨牌觸發；俗稱「直槓」）
 * - `KongConcealed`：暗槓（四張同種全部自摸來；俗稱「暗刻槓」）
 * - `KongAdded`：加槓（已有碰，自摸到第四張時加成槓；俗稱「續槓」）
 */
export const MeldType = {
  Chi: 'chi',
  Pong: 'pong',
  KongExposed: 'kong-exposed',
  KongConcealed: 'kong-concealed',
  KongAdded: 'kong-added',
} as const;

export type TMeldType = (typeof MeldType)[keyof typeof MeldType];

/**
 * 一個副露面子的不可變資料。
 *
 * - `tiles`：3 張（吃/碰）或 4 張（槓）
 * - `fromSeat`：吃/碰/明槓 從哪家拿；暗槓/加槓不適用（undefined）
 */
export type TMeld = {
  readonly type: TMeldType;
  readonly tiles: readonly TTile[];
  readonly fromSeat?: TSeat;
};
